import { motion } from 'framer-motion';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

export const faqs = [
  {
    q: 'Brauche ich Vorwissen in Finanzen?',
    a: 'Nein, rund die Hälfte unserer Berater sind Quereinsteiger, und viel wichtiger als Vorwissen sind Neugier, Disziplin und der Wille sich in ein anspruchsvolles Fachgebiet einzuarbeiten. Die Ausbildung übernehmen wir strukturiert und mit festem Mentor bis hin zu den IHK Qualifikationen §34d und §34f.',
  },
  {
    q: 'Wie verdiene ich als selbstständiger Berater?',
    a: 'Du wirst rein leistungsbezogen über Provisionen und laufende Bestandsvergütungen bezahlt und bekommst in der Startphase Aufbauhilfen damit du finanziell planen kannst. Langfristig entscheidet deine Leistung direkt darüber was du verdienst, und bei uns sind monatliche Einkommen von 10.000 bis 20.000 € realistisch erreichbar.',
  },
  {
    q: 'Was bedeutet Selbstständigkeit, trage ich das volle Risiko?',
    a: 'Du bist rechtlich selbstständig, hast aber weder hohe Fixkosten noch ein Warenlager, und das größte Risiko liegt in deiner eigenen Zeit. Dafür bekommst du freie Einteilung, Steuervorteile und ein Einkommen das nach oben offen bleibt, und wer sich in den ersten Jahren wirklich committet hat am Ende ein sehr planbares Geschäft.',
  },
  {
    q: 'Wie läuft die Ausbildung ab?',
    a: 'Deine Ausbildung ist ein Mix aus internen Trainings, Praxisphasen mit einem erfahrenen Mentor, digitalen Lernmodulen und den IHK Prüfungen, und du hast vom ersten Tag an einen festen Ansprechpartner statt anonymer Onboarding Slides.',
  },
  {
    q: 'Muss ich Kunden mitbringen?',
    a: 'Nein, wir starten dich über unser Netzwerk und unsere spezialisierten Marken Pharmakademie, MediAkademie und IngenieursAkademie, und parallel dazu lernst du wie du dir langfristig einen eigenen Kundenstamm aufbaust weil genau das zum Handwerk gehört.',
  },
  {
    q: 'Für wen ist die Rolle nichts?',
    a: 'Sie passt nicht zu Menschen die ein Fixgehalt mit geregelten Arbeitszeiten suchen oder Beratung mit Verkaufen gleichsetzen, denn wir suchen Menschen die langfristig denken, gerne erklären und Verantwortung für ihre eigene Entwicklung übernehmen.',
  },
];

const FAQSection = () => {
  return (
    <section id="faq" className="section-warm py-20 md:py-28">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <div className="mb-12 text-center">
            <p className="text-[11px] uppercase tracking-[0.22em] text-primary-dark font-semibold mb-4">FAQ</p>
            <h2 className="font-normal text-foreground mb-6">
              Ehrliche Antworten auf <span className="italic text-primary-dark">berechtigte Fragen.</span>
            </h2>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Accordion type="single" collapsible className="space-y-3">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="premium-card px-6 border !border-border"
                >
                  <AccordionTrigger className="text-left text-base md:text-lg font-medium text-foreground hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed text-sm md:text-base pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
